export default __webpack_public_path__ + "static/media/denis-serrano.cffabadd.png";